/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLinkSimple: {
  name: 'link-simple';
  data: string;
} = {
  name: 'link-simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.793 5.207a3.95 3.95 0 0 0-5.586 0l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a5.95 5.95 0 1 1 8.414 8.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a3.95 3.95 0 0 0 0-5.586Zm-4.086 4.086a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0Zm-8 2.414a1 1 0 1 0-1.414-1.414l-1.5 1.5a5.95 5.95 0 0 0 8.414 8.414l1.5-1.5a1 1 0 1 0-1.414-1.414l-1.5 1.5a3.95 3.95 0 0 1-5.586-5.586l1.5-1.5Z" fill="currentColor"/></svg>`,
};
